/**
 * bookingFilterOptions — the option lists and the shared control class, split
 * out so each filter control can live in its own file (one component per file).
 */
import type { BookingSort, BookingStatusFilter } from '../../api/bookingsList';
import type { BookingSource } from '../../api/bookingsV2';

export type StatusValue = BookingStatusFilter | 'all';

export const STATUS_OPTIONS: { value: StatusValue; label: string }[] = [
  { value: 'all', label: 'All' },
  { value: 'confirmed', label: 'Confirmed' },
  { value: 'comp', label: 'Comp' },
  { value: 'rebooked', label: 'Rebooked' },
  { value: 'refunded', label: 'Refunded' },
  { value: 'canceled', label: 'Canceled' },
];

export type SourceValue = BookingSource | 'all';

export const SOURCE_OPTIONS: { value: SourceValue; label: string }[] = [
  { value: 'all', label: 'All' },
  { value: 'nebari', label: 'Nebari' },
  { value: 'fareharbor', label: 'FareHarbor' },
];

export const SORT_OPTIONS: { value: BookingSort; label: string }[] = [
  { value: 'customer', label: 'Customer name' },
  { value: 'status', label: 'Status' },
  { value: 'bookingDate', label: 'Booking date' },
  { value: 'confirmationCode', label: 'Confirmation code' },
];

export const CONTROL =
  'rounded-lg border border-stone-200 bg-white px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-moss-500 dark:border-stone-700 dark:bg-[#1e2520] dark:text-[#e8ece9]';
